export default __webpack_public_path__ + "static/media/F0007.8413027d.png";